import React from 'react';
import Icon from '../../../components/AppIcon';

import Select from '../../../components/ui/Select';

const SortingToolbar = ({ 
  sortBy, 
  onSortChange, 
  viewMode, 
  onViewModeChange,
  totalOffers 
}) => {
  const sortOptions = [
    { value: 'custom', label: 'Custom Order' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'closing-early', label: 'Closing: Earliest First' },
    { value: 'closing-late', label: 'Closing: Latest First' },
    { value: 'submitted-new', label: 'Submitted: Newest First' },
    { value: 'submitted-old', label: 'Submitted: Oldest First' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Icon name="SlidersHorizontal" size={20} className="text-muted-foreground flex-shrink-0" />
          <span className="text-sm md:text-base font-medium text-foreground">
            {totalOffers} {totalOffers === 1 ? 'Offer' : 'Offers'}
          </span>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          <div className="w-full sm:w-64">
            <Select
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              placeholder="Sort by..."
            />
          </div>

          <div className="flex items-center gap-2 bg-muted rounded-lg p-1">
            <button
              onClick={() => onViewModeChange('grid')}
              className={`flex items-center justify-center gap-2 px-3 py-2 rounded-md transition-all duration-250 ${
                viewMode === 'grid' ?'bg-card text-foreground shadow-elevation-sm' :'text-muted-foreground hover:text-foreground'
              }`}
              aria-label="Grid view"
            >
              <Icon name="LayoutGrid" size={18} />
              <span className="text-sm hidden sm:inline">Grid</span>
            </button>
            <button
              onClick={() => onViewModeChange('list')}
              className={`flex items-center justify-center gap-2 px-3 py-2 rounded-md transition-all duration-250 ${
                viewMode === 'list' ?'bg-card text-foreground shadow-elevation-sm' :'text-muted-foreground hover:text-foreground'
              }`}
              aria-label="List view"
            >
              <Icon name="List" size={18} />
              <span className="text-sm hidden sm:inline">List</span>
            </button>
          </div>
        </div>
      </div>

      {sortBy === 'custom' && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-start gap-2 text-sm text-muted-foreground">
            <Icon name="Info" size={16} className="flex-shrink-0 mt-0.5" />
            <p>Drag and drop offers to arrange them in your preferred order. This custom arrangement will be reflected in generated reports.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SortingToolbar;